import { render } from "./red6.vue?vue&type=template&id=6305f1c6&scoped=true"
import script from "./red6.vue?vue&type=script&lang=js"
export * from "./red6.vue?vue&type=script&lang=js"

import "./red6.vue?vue&type=style&index=0&id=6305f1c6&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6305f1c6"]])

export default __exports__